import { faHouseUser } from '@fortawesome/pro-regular-svg-icons/faHouseUser'
import { Box, Grid, TextInput } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { SelectCountry } from '@flecto/ui'
import { CollapsibleCard } from '@flecto/ui'
import useMediaQuery from '@flecto/ui/lib/utils/useMediaQuery'

import { useFormContext } from './FormCustomer'

export function Address() {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })
  const { isMobile } = useMediaQuery()
  const form = useFormContext()

  return (
    <Box mb='lg'>
      <CollapsibleCard>
        <CollapsibleCard.Title>
          {t('add_customer.address')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          {t('add_customer.address_information.description')}
        </CollapsibleCard.Description>
        <CollapsibleCard.Icon withCircleBackground icon={faHouseUser} />
        <CollapsibleCard.Content>
          <TextInput
            mb='md'
            aria-label='address-name'
            label={t('add_customer.address_information.address_name')}
            placeholder={t(
              'add_customer.address_information.address_name_placeholder'
            )}
            {...form.getInputProps('address.label')}
          />
          <Grid>
            <Grid.Col span={12}>
              <TextInput
                mb='md'
                aria-label='address-street'
                label={t('add_customer.address_information.street')}
                placeholder={t(
                  'add_customer.address_information.street_placeholder'
                )}
                {...form.getInputProps('address.address_street')}
              />
            </Grid.Col>
          </Grid>
          <SelectCountry
            style={{ flex: 1 }}
            aria-label='address-country'
            label={t('add_customer.country')}
            placeholder={t('add_customer.country_placeholder')}
            {...form.getInputProps('address.address_country_code')}
          />
          <Grid mt='sm'>
            <Grid.Col span={isMobile ? 12 : 6}>
              <TextInput
                mb='xs'
                aria-label='address-postal-code'
                label={t('add_customer.post_code')}
                placeholder={t('add_customer.post_code_placeholder')}
                {...form.getInputProps('address.address_postal_code')}
              />
            </Grid.Col>
            <Grid.Col span={isMobile ? 12 : 6}>
              <TextInput
                mb='xs'
                aria-label='address-city'
                label={t('add_customer.city')}
                placeholder={t('add_customer.city_placeholder')}
                {...form.getInputProps('address.address_city')}
              />
            </Grid.Col>
          </Grid>
        </CollapsibleCard.Content>
      </CollapsibleCard>
    </Box>
  )
}
